import { render, staticRenderFns } from "./FIBInstallAppModal.vue?vue&type=template&id=3282dca7&scoped=true&"
import script from "./FIBInstallAppModal.vue?vue&type=script&lang=js&"
export * from "./FIBInstallAppModal.vue?vue&type=script&lang=js&"
import style0 from "./FIBInstallAppModal.vue?vue&type=style&index=0&id=3282dca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3282dca7",
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QSeparator,QItem});
